import { Button, Text } from 'native-base'

import SparkleSVG from '../../../assets/SparkleSVG'

interface TrackAnotherPackageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onBackToSearch: (e: any) => void
}

export const TrackAnotherPackage = ({ onBackToSearch }: TrackAnotherPackageProps) => {
  return (
    <Button
      onPress={onBackToSearch}
      size="sm"
      width="250px"
      height="32px"
      borderRadius={100}
      bgColor="brand.lightGrey"
      leftIcon={<SparkleSVG />}
    >
      <Text color="brand.softBlack" fontWeight={500} fontSize={16}>
        Track Another Package
      </Text>
    </Button>
  )
}
